/**
 * Sarthi Mart — "Added to cart" toast
 * assets/cart-add-toast.js
 *
 * Lightweight, dependency-free toast shown after a successful ajax
 * add-to-cart, now that the cart drawer no longer auto-opens on every add.
 * Gives the shopper a "View cart" shortcut instead.
 */
(function () {
  var CONTAINER_ID = "sarthi-cart-toast";
  var AUTO_DISMISS_MS = 3500;
  var hideTimer = null;

  function openCart() {
    var cartDrawer = document.getElementById("MinimogCartDrawer") || document.querySelector("m-cart-drawer");
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
      return;
    }
    var cartUrl = (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart) || "/cart";
    window.location.href = cartUrl;
  }

  function hide() {
    var el = document.getElementById(CONTAINER_ID);
    if (el) el.classList.remove("is-visible");
  }

  function ensureContainer() {
    var el = document.getElementById(CONTAINER_ID);
    if (el) return el;

    el = document.createElement("div");
    el.id = CONTAINER_ID;
    el.className = "sarthi-cart-toast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    el.innerHTML =
      '<span class="sarthi-cart-toast__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="10" cy="10" r="10" fill="currentColor" opacity="0.15"></circle>' +
          '<path d="M6 10.3l2.4 2.4L14.3 6.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>' +
      '<span class="sarthi-cart-toast__text"></span>' +
      '<button type="button" class="sarthi-cart-toast__action"></button>' +
      '<button type="button" class="sarthi-cart-toast__close" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(el);

    el.querySelector(".sarthi-cart-toast__action").addEventListener("click", function () {
      hide();
      openCart();
    });
    el.querySelector(".sarthi-cart-toast__close").addEventListener("click", hide);

    return el;
  }

  function show(message, actionLabel) {
    clearTimeout(hideTimer);
    var el = ensureContainer();
    el.querySelector(".sarthi-cart-toast__text").textContent = message;
    el.querySelector(".sarthi-cart-toast__action").textContent =
      actionLabel || (window.MinimogStrings && window.MinimogStrings.viewCart) || "View cart";

    // Restart the entrance transition even if a toast is already showing.
    el.classList.remove("is-visible");
    void el.offsetWidth;
    requestAnimationFrame(function () {
      el.classList.add("is-visible");
    });

    hideTimer = setTimeout(hide, AUTO_DISMISS_MS);
  }

  window.SarthiCartToast = { show: show, hide: hide };
})();
